<template>
    <div>
        <!-- import account -->
        <app-account></app-account>

        <!-- alerts contents -->
        <div class="container spread-out">
            <div class="row alert alert-secondary mx-1 mt-5">
                <div class="col-lg-9 col-md-12 col-sm-12 col-12">
                    <p class="mobile-text-center">Let's notify you when we find that item you need but can't find here at the moment</p>
                </div>
                <div class="col-lg-3 col-md-12 col-sm-12 col-12 mobile-text-center">
                    <button @click="showCreateAlert = true" class="btn btn-dark-green">Create an alert</button>
                </div>
            </div>
            <template v-if="myAlerts">
                <div class="row mx-1 mt-5">
                    <h3 class="md-small-text">My Previous Alerts</h3>
                    <div class="table-responsive">
                        <table class="table table-striped no-wrap mt-2">
                            <thead>
                                <tr>
                                    <th scope="col">No.</th>
                                    <th scope="col">Items to search for</th>
                                    <th scope="col">Notified</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(alert, i) in myAlerts" :key="i">
                                    <th scope="row">{{ i+1 }}.</th>
                                    <td>
                                        <router-link :to="{ name: 'alert', params: { id: alert._id } }">
                                            <span @click="viewSingleAlert(alert._id)">
                                                {{alert.note | capitalize}} <i class="fas fa-external-link-square-alt text-dark-green"></i>
                                            </span>
                                        </router-link>
                                    </td>
                                    <td>
                                        <i v-if="alert.alerted" class="fas fa-check text-dark-green" title="Already notified you via email"></i>
                                        <i v-else class="fas fa-sync-alt text-warning" title="Still searching for results"></i>
                                    </td>
                                    <td>
                                        <i @click="toRemoveAlert(alert._id)" class="fas fa-trash-alt text-danger clickable" title="Delete notify-me alert"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="row my-5">
                    <div class="col-12 text-muted">
                        <center>
                            <i class="far fa-bell-slash fa-5x my-3"></i>
                            <h5>Hi {{user.name | capitalize}}, you haven't created any notify-me alert yet.</h5>
                        </center>
                    </div>
                </div>
            </template>
        </div>

        <!-- create new alert -->
        <app-ghost-mode v-if="showCreateAlert">
            <div class="row">
                <div class="col-12">
                    <div class="jumbotron screen-center p-4">
                        <h3 class="my-3 md-small-text">What item will you like to be notified about?</h3>
                        <!-- Alert Messages -->
                        <div v-if="msg !== ''" class="row mt-3 mb-4">
                            <dd class="col-12">
                                <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                                </div>
                            </dd>
                        </div>
                        <div class="form-group">
                            <textarea v-model="note" class="form-control no-lines bg-white" rows="5"></textarea>
                        </div>
                        <button @click="createNewAlert" class="loadn btn btn-dark-green form-control btn-lg">Create Alert</button>
                    </div>
                </div>
            </div>
        </app-ghost-mode>

        <!-- view a selected alert -->
        <app-ghost-mode v-if="viewAlert && alertDetails">
            <div class="row">
                <div class="col-12">
                    <div class="jumbotron screen-center p-4">
                        <h3 class="my-4">Alert Details</h3>
                        <dl class="row">
                            <dt class="col-sm-3">Item to search:</dt>
                            <dd class="col-sm-9"><p>{{alertDetails.note | capitalize}}</p></dd>

                            <dt class="col-sm-3">Notified User:</dt>
                            <dd class="col-sm-9">
                                <p>
                                    <span v-if="alertDetails.alerted">Yes</span>
                                    <span v-else>No</span>
                                </p>
                            </dd>

                            <template v-if="alertDetails.alerted">
                                <dt class="col-sm-3">Results found:</dt>
                                <dd class="col-sm-9">
                                    <p> Emailed to "<router-link :to="{ name: 'profile' }" class="text-dark-green">{{user.email}}</router-link>" </p>
                                </dd>
                            </template>
                            
                            <dt class="col-sm-3">Alert Created:</dt>
                            <dd class="col-sm-9"><p>{{alertDetails.joined | moment("MMM Do YYYY")}}</p></dd>
                            
                            <dt class="col-12 mt-4">
                                <button @click="toRemoveAlert(alertDetails._id)" class="loadn btn btn-danger"><i class="fas fa-trash-alt"></i> Remove Alert</button>
                            </dt>
                        </dl>
                    </div>
                </div>
            </div>
        </app-ghost-mode>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

import Account from '../shared/Account.vue'
import GhostMode from '@/components/general/shared/GhostMode.vue'
import LayoutUser from '@/layouts/User.vue'

export default {
    name: "Alerts",
    data() {
        return {
            showCreateAlert: false,
            viewAlert: false,
            alertDetails: false,
            note: '',
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['createAlert', 'fetchAlerts', 'removeAlert', 'footerFixed', 'scanForResults']),
        createNewAlert() {
            this.color = "danger"
            if(this.note === ''){ this.msg = "What item will you like to be notified on?"; return }
            // build the alert object
            let alertObj = {
                userId: this.user._id,
                note: this.note
            }
            this.createAlert(alertObj)
            .then(() => {
                this.color = "success"
                this.msg = "Notify-me alert successfully created!"
                this.note = ""
            })
            .catch((e) => {
                this.msg = "Creating alert failed, do try again."
            })
        },
        toRemoveAlert(alertId) {
            // build alert object
            let alertObj = {
                userId: this.user._id,
                alertId: alertId
            }
            this.removeAlert(alertObj)
            .then(() => {
                this.viewAlert = false
            })
            .catch((e) => {})
        },
        viewSingleAlert(alertId) {
            this.viewAlert = true
            // fetch the alert details from the getters.alerts
            let fullAlertDetails = this.alerts.find(alert => alert._id == alertId)
            return this.alertDetails = fullAlertDetails
        }
    },
    computed: {
        ...mapGetters(['alerts', 'user']),
        myAlerts() {
            if(this.alerts && this.alerts !== null){
                if(this.alerts.length < 4){ this.footerFixed(true) }
                else { this.footerFixed(false) }
                return this.alerts
            }
            this.footerFixed(true)
            return false
        },
    },
    components: {
        appAccount: Account,
        appGhostMode: GhostMode
    },
    watch: {
        $route(){
            this.scanForResults().then(() => {}).catch((e) => {})
        }
    },
    created() {
        this.fetchAlerts().then(() => {}).catch((e) => {})
        this.scanForResults().then(() => {}).catch((e) => {})
        eventBus.$on('hideGhostMode', (value) => {
            this.showCreateAlert = value;
            this.viewAlert = value;
        }),
        this.$emit('update:layout', LayoutUser);
    }
}
</script>